
// 是否是携程整租分享页面
export const isCtripShare = (extraData) => {
    if(extraData && extraData.type === '1') {
         return `/order/shareReceipt/${extraData.receiptId}`
    }
    return ''
};